import React, { FC } from 'react';
import styled from 'styled-components';
import {
  BROWSER_BREAKPOINTS,
  DetailsItem,
  DetailsWrapper,
  Typography,
} from '@flicent/fieldpulse-react-component-library-frontend';

import JobSubtasksProps from './JobSubtasks.props';


const StyledRoot = styled.div`
  display: grid;
  grid-row-gap: 50px;

  font-family: "Open Sans", sans-serif;

  @media screen and (${ BROWSER_BREAKPOINTS.MOBILE }) {
    grid-row-gap: 16px;
  }
`;

const StyledItem = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 20px;
`;

const JobSubtasks: FC<JobSubtasksProps> = ({ job }) => {
  if (!job.is_subtasks_visible || !job.subtasks.length) {
    return null;
  }

  return (
    <StyledRoot>
      {
        job.subtasks.map(({ title, status_name, description, due_date, members }, index) => (
          <StyledItem key={ index }>
            <Typography variant="h1" color="blue">{ title }</Typography>

            <DetailsWrapper>
              <DetailsItem label="Due Date" value={ due_date }/>
              <DetailsItem label="Description" value={ description }/>
              <DetailsItem label="Status" value={ status_name }/>
              <DetailsItem label="Assigned Team Members" value={ members }/>
            </DetailsWrapper>
          </StyledItem>
        ))
      }
    </StyledRoot>
  );
};


export default JobSubtasks;